// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"533488c0","453":"6c226ce5","506":"e5ef8e92","569":"7c37afeb","594":"3c13dd8f","707":"dc68cdb3","784":"6b7f542e","850":"9191e697"}[chunkId] + ".chunk.js";
};